import { render, staticRenderFns } from "./profileModal.vue?vue&type=template&id=3d2a1ff4&scoped=true&"
import script from "./profileModal.vue?vue&type=script&lang=js&"
export * from "./profileModal.vue?vue&type=script&lang=js&"
import style0 from "./profileModal.vue?vue&type=style&index=0&id=3d2a1ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a1ff4",
  null
  
)

export default component.exports